
import { Button, Checkbox, Form, Input, Modal, Popover } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formItemLayout, tailFormItemLayout } from '../../utils/antUtils';
import { cancelDb, editInput, saveDb } from '../configActions';
const FormItem = Form.Item;

class ConfigDatabaseModalComponent extends Component {

  state = {
    
  }

  cancelDialog() {
    this.props.dispatch(cancelDb());
  }

  submit() {

    this.props.form.validateFields((errors) => {
      if (errors) {
        return false;
      }

      this.props.dispatch(saveDb(this.props.db));
    });
  }

  onChange(value, entity, attr) {
    this.props.dispatch(editInput({ value, entity, attr }));
  }

  render() {
    
    const { getFieldDecorator } = this.props.form;

    let footer = [];

    footer.push(<Button key="back" onClick={() => this.cancelDialog()}>Avbryt</Button>);
    footer.push(<Button key="submit" type="primary" onClick={() => this.submit()}>Spara</Button>);

    return (

      <Modal
        title='Databas'
        visible={this.props.db.show}
        onCancel={() => this.cancelDialog()}
        footer={footer}
        maskClosable={false}
      >
        <div>
          <Form onSubmit={this.handleSubmit}>
            <FormItem {...formItemLayout} label="Bokstav" >
              {getFieldDecorator('dbKey', { rules: [{ required: true, message: 'Ange en bokstav' }], })(<Input disabled={!this.props.db.new} onBlur={(e) => this.onChange(e.target.value, 'db', 'key')} autoFocus />)}
            </FormItem>
            <FormItem {...formItemLayout} label="Namn" >
              {getFieldDecorator('dbName', { rules: [{ required: true, message: 'Ange ett namn' }], })(<Input onBlur={(e) => this.onChange(e.target.value, 'db', 'name')} />)}
            </FormItem>
            <FormItem {...formItemLayout} label="Ansvarig Jurist" >
              {getFieldDecorator('dbResponsibleLawyer')(<Input onBlur={(e) => this.onChange(e.target.value, 'db', 'responsibleLawyer')} />)}
            </FormItem>
            <FormItem {...tailFormItemLayout}>
              {getFieldDecorator('dbHidden', { valuePropName: 'checked' })(<Checkbox onChange={(e) => this.onChange(e.target.checked, 'db', 'hidden')}>Är dold för kund</Checkbox>)}
            </FormItem>
          </Form>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  loading: state.config.loading,
  databases: state.config.databases,
  db: state.config.db
});

export default connect(mapStateToProps)(Form.create({
  mapPropsToFields(props) {

    return {
      dbKey: Form.createFormField({ value: props.db.key }),
      dbName: Form.createFormField({ value: props.db.name }),
      dbResponsibleLawyer: Form.createFormField({ value: props.db.responsibleLawyer }),
      dbHidden: Form.createFormField({ value: props.db.hidden })
    }
  }
})(ConfigDatabaseModalComponent));


// WEBPACK FOOTER //
// ./src/config/dialogs/configDatabaseModalComponent.js